import axios from "axios";
import globalStore from "@/utils/global-store";
import NavigationService from "@/services/NavigationService"
import apiConfig from '@/config/api';
//import store from "@/store";

//const globalStore = getGlobalStore();

export const authClient = axios.create({
    baseURL: apiConfig.baseUrl,
    withCredentials: true, // required to handle the CSRF token
});

/*
 * Add a response interceptor
 */
authClient.interceptors.response.use(
    (response) => {
        if( (response.headers['x-authenticated'] || '0') === '1' ) {
            // session is authenticated!
            // important: if header is not present, we can not determine if logged in or not!
            globalStore.set({
                loggedIn: true,
                authFailed: false,
            });
        }
        return response;
    },
    function (error) {
        if( error.response && [401, 419].includes(error.response.status) ) {
            console.warn('api returned 401/419 => not authenticated');
            globalStore.unauthenticatedResponseReceived();
        }
        return Promise.reject(error);
    }
);
authClient.interceptors.request.use(
    (config) => {
        // config.xsrfCookieName
        return config;
    }, (error) => {
        // Do something with request error
        return Promise.reject(error);
    }
);

export default {
    async login(payload: any) {
        await authClient.get("/csrf-cookie");
        return authClient.post("/login", payload).then(response => {
            globalStore.set('loggedIn', true);
            // NavigationService.navigateLoginSuccessful();
            return response;
        });
    },
    logout() {
        return authClient.post("/logout").then((response) => {
            globalStore.set('loggedIn', false);
            //globalStore.data.authFailed = true;
            // NavigationService.navigateLogoutSuccessful();
            return response;
        });
    },
    async forgotPassword(payload: any) {
        await authClient.get("/csrf-cookie");
        return authClient.post("/forgot-password", payload);
    },
    getAuthUser() {
        return authClient.get("/user");
    },
    async resetPassword(payload: any) {
        await authClient.get("/csrf-cookie");
        return authClient.post("/reset-password", payload);
    },
    updatePassword(payload: any) {
        return authClient.put("/user/password", payload);
    },
    async registerUser(payload: any) {
        await authClient.get("/csrf-cookie");
        return authClient.post("/register", payload);
    },
    sendVerification(payload: any) {
        return authClient.post("/email/verification-notification", payload);
    },
    updateUser(payload: any) {
        return authClient.put("/user/profile-information", payload);
    },

    passwordResetRequest(email: string) {
        return authClient.post("/password/reset-request", { email });
    },
};
